import { MarketplacesAppRouter } from './MarketplacesAppRouter';
export function MarketplacesApp(props) {
    return (<MarketplacesAppRouter url={props.userMarketplacesIds.length == 1 ? `/marketplace/${props.userMarketplacesIds[0]}` : "/"}/>);
}
